import { BackendAdapterCube, ICubeResponse } from "@spawn/backend-adapter-cube";
import { consumer, inject } from "@spawn/core";
import { FreegameSpinActionCube } from "@spawn/freegames";
import { parseNudgeNetworkState } from "@spawn/nudge";
import { parseRevealNetworkState } from "@spawn/reveal";
import { SymbolService } from "../../services/symbolService";
import { UncoverTierService } from "../../services/uncoverTierService";
import { invertNudgingOffsets, mapCalaverasToGoldenBonus } from "../hacks";
import { getWonFGScatterCount } from "../helpers";
import { IGameNetworkState } from "../networkState";
import { INrgCubeGameResult } from "../types/cube";

@consumer
export class FGSpinActionCube extends FreegameSpinActionCube {
	@inject protected readonly uncoverTierService!: UncoverTierService;
	@inject protected readonly symbolService!: SymbolService;

	public override parse(response: ICubeResponse<INrgCubeGameResult>, adapter: BackendAdapterCube): IGameNetworkState {
		const transition = response.response.transition;
		const result = super.parse(response, adapter) as IGameNetworkState;
		this.symbolService.replaceSwingingMysteriesIfNotNeeded(result.slotGameBase.reels);
		const uncoverTier = this.uncoverTierService.fromWinFactor(result.slotGameBase.winFactor);

		const triggerSpin = transition.slotGame.nudgeAndReveal.triggerSpin;
		const fgTriggerState =
			triggerSpin !== undefined
				? {
						reels: triggerSpin.reels,
						reveal: mapCalaverasToGoldenBonus(parseRevealNetworkState(triggerSpin, uncoverTier)),
						nudging: invertNudgingOffsets(parseNudgeNetworkState(triggerSpin)),
					}
				: undefined;

		const feature: Partial<IGameNetworkState> = {
			reveal: mapCalaverasToGoldenBonus(parseRevealNetworkState(transition.slotGame.nudgeAndReveal, uncoverTier)),
			nudging: invertNudgingOffsets(parseNudgeNetworkState(transition.slotGame.nudgeAndReveal)),
			fgTriggerState,
		};

		if (getWonFGScatterCount(feature.reveal) > 0) {
			feature.preNudgeUpReels = transition.slotGame.reels;
		}

		return {
			...result,
			...feature,
		};
	}
}
